import React from 'react'
import InspectionManual from './InspectionManual'
import SampleReports from './SampleReports'
import './inspection-sections.css'

const InspectionSections = () => {
  return (
    <div className="inspection-sections-container">
      <div className="inspection-sections-wrapper">
        <div className="inspection-section-left">
          <InspectionManual />
        </div>
        
        <div className="inspection-section-right">
          <SampleReports />
        </div>
      </div>
    </div>
  )
}

export default InspectionSections
